import React from 'react';
import {  isAndroid, isIOS } from '../helper/getMobileOS';
const BaseURL = process.env.REACT_APP_BASE_URL;

/**
 * Arena Table component
 * @param {number} tableNumber
 * @param {number} tablePrice
 * @param {string} tableState ['booked', 'hold', 'selected', 'available', 'NA', 'system']
 * @returns JSX Arena Table
 */
export default function ArenaTable({ tableNumber, tablePrice, renderPrice = false, onClick, customClassName = "", state = 'available', ...props }) {

    const mapStateToHtmlClass = {
        "booked": "isBookedTable",
        "hold": 'isHoldedTable',
        "selected": 'isSelectedTable',
        "available": '',
        "NA": 'notavailableTable',
        "system": "isSystemTable"
    }

    if (!!onClick && onClick.constructor !== Function) {
        throw new Error("onClick is required and to be a function.");
    }
    const isAndroidDevice = isAndroid();
    const isIOSDevice = isIOS();

    const fontSize = isIOSDevice ? 5 : isAndroidDevice ? 2 : 5;
    const bottom = isIOSDevice ? -4 : isAndroidDevice ? -8 : -4;
    const right = isAndroidDevice?-10:0

    return (
        <div
            className={`bookingTable ${mapStateToHtmlClass[state]} ${customClassName}`}
            onClick={['available', 'selected'].indexOf(state) > -1 ? onClick : null}
            {...props}
        >
            <img src={`${BaseURL}/assets/img/bookingtable.png`} alt={`Table ${tableNumber}`} />
            {!!tablePrice && tablePrice > 0 &&
                <div style={{ fontSize: '9px', position: 'relative', display: renderPrice ? 'block' : 'none' }}>
                    {tablePrice.toLocaleString('en-US')}
                    <span style={{ fontSize: fontSize, position: 'absolute', bottom: bottom, right: right }}>AED</span>
                </div>
            }
            <div className={`TableNumber ${renderPrice ? '' : 'mt-2'}`}>
                {tableNumber}
            </div>
        </div>
    );
}
